function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Info = function Info(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0m0 2C6.486 2 2 6.486 2 12s4.486 10 10 10c5.513 0 10-4.486 10-10S17.513 2 12 2m0 7.99a1 1 0 0 1 1 1v6.089a1 1 0 1 1-2 0v-6.09a1 1 0 0 1 1-1m0-4.068a1.249 1.249 0 1 1 0 2.497 1.249 1.249 0 0 1 0-2.497"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillOpacity: 0.2,
    d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0m0 2C6.486 2 2 6.486 2 12s4.486 10 10 10c5.513 0 10-4.486 10-10S17.513 2 12 2m0 7.99a1 1 0 0 1 1 1v6.089a1 1 0 1 1-2 0v-6.09a1 1 0 0 1 1-1m0-4.068a1.249 1.249 0 1 1 0 2.497 1.249 1.249 0 0 1 0-2.497"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M0 0h24v24H0z"
  }))));
};
export default Info;